"use client";

import { c as _c } from "react/compiler-runtime";
import { getNotificationsRoute } from "@/helpers/navigation.helpers";
import useCapacitor from "@/hooks/useCapacitor";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import React, { useCallback, useMemo, useRef } from "react";
import { useLayout } from "../brain/my-stream/layout/LayoutContext";
import BellIcon from "../common/icons/BellIcon";
import ChatBubbleIcon from "../common/icons/ChatBubbleIcon";
import HomeIcon from "../common/icons/HomeIcon";
import LogoIcon from "../common/icons/LogoIcon";
import Squares2X2Icon from "../common/icons/Squares2X2Icon";
import UsersIcon from "../common/icons/UsersIcon";
import WavesIcon from "../common/icons/WavesIcon";
import NavItem from "./NavItem";
import type { NavItem as NavItemData } from "./navTypes";
const items: NavItemData[] = [{
  kind: "route",
  name: "Home",
  href: "/",
  icon: "home",
  iconComponent: HomeIcon
}, {
  kind: "view",
  name: "Waves",
  viewKey: "waves",
  icon: "waves",
  iconComponent: WavesIcon,
  iconSizeClass: "tw-size-6"
}, {
  kind: "view",
  name: "Messages",
  viewKey: "messages",
  icon: "messages",
  iconComponent: ChatBubbleIcon
}, {
  kind: "route",
  name: "Stream",
  href: "/",
  icon: "stream",
  iconComponent: LogoIcon,
  iconSizeClass: "tw-size-9"
}, {
  kind: "route",
  name: "Network",
  href: "/network",
  icon: "network",
  iconComponent: UsersIcon
}, {
  kind: "route",
  name: "Collections",
  href: "/the-memes",
  icon: "collections",
  iconComponent: Squares2X2Icon
}, {
  kind: "route",
  name: "Notifications",
  href: "/notifications",
  icon: "notifications",
  iconComponent: BellIcon
}];
interface BottomNavigationProps {
  readonly hidden?: boolean | undefined;
}
const BottomNavigation: React.FC<BottomNavigationProps> = t0 => {
  const $ = _c(12);
  const {
    hidden: t1
  } = t0;
  const hidden = t1 === undefined ? false : t1;
  const {
    registerRef
  } = useLayout();
  const {
    isAndroid
  } = useCapacitor();
  const {
    isApp
  } = useDeviceInfo();
  const mobileNavRef = useRef(null);
  let t2;
  if ($[0] !== registerRef) {
    t2 = node => {
      mobileNavRef.current = node;
      registerRef("mobileNav", node);
    };
    $[0] = registerRef;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const setMobileNavRef = t2;
  let t3;
  if ($[2] !== isApp) {
    t3 = items.map(item => item.name === "Notifications" ? {
      ...item,
      href: getNotificationsRoute(isApp)
    } : item);
    $[2] = isApp;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const navItems = t3;
  const paddingClass = isAndroid ? "tw-pb-[env(safe-area-inset-bottom,0px)]" : "";
  const hiddenStyle = hidden ? "tw-opacity-0 tw-translate-y-full tw-pointer-events-none" : "tw-opacity-100 tw-translate-y-0";
  const t4 = `${paddingClass} ${hiddenStyle} tw-fixed tw-left-0 tw-w-full tw-bottom-0 tw-bg-black tw-border-t tw-border-solid tw-border-x-0 tw-border-b-0 tw-border-iron-900 tw-shadow-inner tw-z-50 tw-transition-[opacity,transform] tw-duration-75`;
  let t5;
  if ($[4] !== navItems) {
    t5 = navItems.map(_temp);
    $[4] = navItems;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <div className="tw-h-full"><ul className={"tw-flex tw-h-full tw-pl-[env(safe-area-inset-left,0px)]\n    tw-pr-[env(safe-area-inset-right,0px)] md:tw-max-w-2xl tw-mx-auto"}>{t5}</ul></div>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== setMobileNavRef || $[9] !== t4 || $[10] !== t6) {
    t7 = <nav ref={setMobileNavRef} className={t4}>{t6}</nav>;
    $[8] = setMobileNavRef;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export default BottomNavigation;
function _temp(item_0) {
  return <li key={item_0.name} className={`tw-flex tw-flex-1 tw-justify-center tw-items-end ${item_0.name === "Stream" ? "-tw-translate-y-1" : ""} tw-h-full tw-min-w-0`}><NavItem item={item_0} /></li>;
}